<template>
  <!-- 发件箱 -->
  <div style="padding: 30px">
    <div class="my-title">发件箱</div>
    <!-- 批量操作 -->
    <div class="deaft_opertaction">
      <!-- <div class="">
          批量操作
      </div> -->
    </div>
    <!-- 表格  -->
    <div class="draftsTable">
      <el-table
        :data="tableDataList"
        :header-cell-style="{
          color: '#848484',
          background: '#f4f4f4',
          textAlign: 'center',
        }"
        border
        style="width: 100%"
        :cell-style="{ textAlign: 'center' }"
      >
        <el-table-column prop="title" label="标题" width="180">
        </el-table-column>
        <el-table-column prop="content" label="内容" width="180">
        </el-table-column>
        <el-table-column label="收件人">
          <template slot-scope="scope">
            {{ scope.row.to_user.nickname }}
          </template>
        </el-table-column>
        <el-table-column prop="createtime" label="时间" :formatter="dateFormat">
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <span @click="outBox(scope.row.id)">删除</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <div class="shopp_pagination">
      <el-button
        size="small"
        style="width: 80px; height: 30px"
        @click="pervious"
        >上一页</el-button
      >
      <el-pagination
        ref="pageGroup"
        :current-page="currentPage"
        :page-size="pageSize"
        @current-change="handleCurrentChange"
        background
        layout="pager"
        :total="total"
      >
      </el-pagination>
      <el-button style="width: 80px; height: 30px" size="small" @click="next"
        >下一页</el-button
      >
    </div>
  </div>
</template>

<script>
if (localStorage.getItem("userInfo")) {
  var token = JSON.parse(localStorage.getItem("userInfo")).token;
  var header = {
    "Content-Type": "application/json",
    token: token,
    platform: "H5",
  };
}
import { userLetterIndex, userLetterDel } from "@/api/index.js";
export default {
  data() {
    return {
      tableData: [],
      total: 1,
      currentPage: 1,
      pageSize: 4,
    };
  },
  created() {
    this.getOutBox();
  },
  methods: {
    //收件箱列表
    getOutBox() {
      userLetterIndex({ type: 3 }, header).then((res) => {
        this.tableData = res.data.lists;
        this.total = res.data.count;
        console.log(res);
      });
    },
    dateFormat(row, column) {
      let date = row[column.property];
      //console.log(moment);
      if (date == undefined) {
        return "";
      }
      return this.moment(date*1000).format("YYYY.MM.DD");
    },
    outBox(id) {
      userLetterDel({ ids: id, type: 3 }, header).then((res) => {
        if (res.code !== 1) {
          return this.$message.error(res.msg);
        }
        this.$message.success(res.msg);
        this.getOutBox();
      });
    },
    //上一页
    pervious() {
      this.$refs.pageGroup.prev();
    },
    //下一页
    next() {
      this.$refs.pageGroup.next();
    },
    handleCurrentChange(newNum) {
      this.currentPage = newNum;
    },
  },
  computed: {
    tableDataList: function () {
      return this.tableData.slice(
        (this.currentPage - 1) * this.pageSize,
        this.currentPage * this.pageSize
      );
    },
  },
};
</script>
<style lang="less" scoped>
.shopp_pagination {
  display: flex;
  justify-content: center;
  margin-top: 60px;
}
.my-title {
  // height: 40px;
  font-size: 20px;
  padding: 0 10px;
  border-left: 5px solid #ff6701;
  margin-bottom: 10px;
  margin-left: -10px;
}
.draftsTable {
  width: 901px;
  margin-top: 16px;
}
.deaft_opertaction {
  width: 901px;
  height: 18px;

  div {
    width: 72px;
    height: 18px;
    font-size: 18px;
    font-family: SourceHanSansCN-Medium, SourceHanSansCN;
    font-weight: 500;
    color: #0093f8;
    line-height: 27px;
    float: right;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/index/mine/components/outBox.vue